module.exports = __webpack_public_path__ + "static/media/right-chevron.7841036f.svg";